import productsList from '../../../services/productsList/productsList.js';

const actions = {
  filterUpdate(context, data) {
    context.commit('updateFilterOptions', data);

    if (data.updatePageOnChange) {
      context.dispatch('pageUpdate', {resetPage: true});
    }
  },
  filterPriceRangeUpdate(context, data) {
    context.commit('updateFilterRange', data);

    if (data.updatePageOnChange) {
      context.dispatch('pageUpdate', {resetPage: true});
    }
  },
  prevPage(context) {
    if (context.state.pagination.currentPage > 1) {
      context.commit('updateCurrentPage', {value: context.state.pagination.currentPage - 1});
      context.dispatch('pageUpdate');
    }
  },
  nextPage(context) {
    if (context.state.pagination.currentPage < context.state.pagination.pagesCount) {
      context.commit('updateCurrentPage', {value: context.state.pagination.currentPage + 1});
      context.dispatch('pageUpdate');
    }
  },
  gotoPage(context, data) {
    if (data.value >= 1 && data.value <= context.state.pagination.pagesCount) {
      context.commit('updateCurrentPage', {value: data.value});
      context.dispatch('pageUpdate');
    }
  },
  sortProducts(context, data) {
    context.commit('updateSortValue', {value: data.value});
    context.dispatch('pageUpdate', {resetPage: true});
  },
  pageUpdate(context, options = {}) {
    if (options.resetPage) {
      context.commit('updateCurrentPage', {value: 1});
    }

    let urlParameters = context.getters.urlParameters;

    productsList()
      .getProductsList(urlParameters)
      .then(data => {
        if (data) {
          context.dispatch('updateState', data, true);
        }
    });
  },
  updateState(context, data) {
    context.commit('updateProductsList', data.state.elementsList);
    context.commit('updateFiltersState', data.state.filters);
    context.commit('updatePagination', data.state.pagination);
    context.commit('updateHeadline', data.state.headline);
    context.commit('updateResultCount', data.state.resultCount);
    context.dispatch('historyPushState', {url: data.url});
  },
  historyPushState(context, data) {
    const serializableData = {
      productsList: JSON.parse(JSON.stringify(context.state.elementsList || [])),
      filters: JSON.parse(JSON.stringify(context.state.filters || {})),
      pagination: JSON.parse(JSON.stringify(context.state.pagination || {})),
      sorting: JSON.parse(JSON.stringify(context.state.sorting || {}))
    };

    window.history.pushState(
      serializableData,
      document.title,
      data.url
    );
  },
  historyPopState(context, eventData) {
    context.commit('updateProductsList', eventData.state.productsList);
    context.commit('updateFiltersState', eventData.state.filters);
    context.commit('updateCurrentPage', {value: eventData.state.pagination.currentPage});
    context.commit('updateSortValue', {value: eventData.state.sorting.selectedOptionValue});
  },
  removeActiveFilterOption(context, data) {
    context.commit('removeActiveFilterOption', data);

    if (data.updatePageOnChange) {
      context.dispatch('pageUpdate', {resetPage: true});
    }
  },
  removeAllActiveFilterOptions(context, data) {
    context.commit('removeAllActiveFilterOptions');

    if (data.updatePageOnChange) {
      context.dispatch('pageUpdate', {resetPage: true});
    }
  },
  updateProduct(context, updatedData){
    context.commit('updateProductOnList', updatedData)
  }
};

export default actions;
